import React, { useState, useEffect } from "react";
import { useQuery } from "Hooks/index";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { Tabs } from "@life-line-lab/components-react";
import BoxComponent from "Components/fullscreen-configuration/box-component/box-component";

interface BoxesFullScreenProps {
  boxesObj: any;
}

const BoxesFullScreen: React.FC<BoxesFullScreenProps> = ({ boxesObj }) => {
  const { t } = useTranslation();
  const query = useQuery();
  const [boxArray, setBoxArray] = useState<any>([]);

  useEffect(() => {
    if (!isEmpty(boxesObj)) {
      handleBoxesTabs();
    }
  }, [boxesObj]);

  const initialTabs = [];

  const [tabs, setTabs] = useState<any>(initialTabs);

  const setupBoxComponent = (targetRack) => {
    return {
      tabKey: targetRack?.tabkey,
      label: targetRack?.tabName,
      component: (
        <BoxComponent filteredColumns={targetRack} noOfColumns={targetRack?.noOfColumns} />
      ),
    };
  };

  const handleBoxesTabs = () => {
    let currentRack: any = [];

    // initialise rack the first time
    if (isEmpty(boxArray)) {
      currentRack = boxesObj?.map((targetRack) => setupBoxComponent(targetRack));
      setBoxArray && setBoxArray(boxesObj);
    } else {
      // if any rack is updated, find that rack using tabCode and only replace the contents without changing the order
      currentRack = boxArray?.map((box) => {
        const targetRack = boxesObj?.filter((targetBox) => targetBox?.tabCode == box?.tabCode);
        return setupBoxComponent(targetRack[0]);
      });
    }

    setTabs && setTabs(currentRack);
  };

  // useState
  const tabKey = query.get("tabKey") || "0";
  const [tabActiveKey, setTabActiveKey] = useState(tabKey);

  const handleTabClick = (key: string) => {
    setTabActiveKey(key);
  };

  return (
    <div className="dm-fullscreen dm-fs-boxes">
      <Tabs
        destroyInactiveTabPane={true}
        onTabClick={handleTabClick}
        defaultActiveKey={tabActiveKey}
        activeKey={tabActiveKey}
        tabBarGutter={25}
        tabs={tabs}
      />
    </div>
  );
};

export default BoxesFullScreen;
